var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_54788",
    "data-name": "Group 54788",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 146.167,
    height: 52.918,
    viewBox: "0 0 146.167 52.918",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8791",
    "data-name": "Rectangle 8791",
    width: 146.167,
    height: 52.918,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86198",
    "data-name": "Path 86198",
    d: "M26.29,8.955A24.416,24.416,0,0,0,11.6,42.247C15.509,51,22.576,55.8,32.052,56.9A23.243,23.243,0,0,0,46.191,53.98a4.515,4.515,0,0,0,.337-7.869c-1.78-1.122-3.544-.8-5.336.107A14.529,14.529,0,0,1,30.6,47.383c-6.414-1.724-10.489-5.925-11.683-12.4a14.554,14.554,0,0,1,5.924-15.008c5.229-3.937,10.966-4.379,16.824-1.389a15.391,15.391,0,0,1,7.177,19.36c-1.518,3.809-1.21,5.033,1.941,7.664,3.185,2.658,6.364,5.322,9.564,7.962a4.588,4.588,0,1,0,5.9-7c-2.38-2.026-4.773-4.038-7.209-6a1.677,1.677,0,0,1-.7-2.009,21.267,21.267,0,0,0,.858-6.217,33.322,33.322,0,0,0-.255-3.562,25,25,0,0,0-1.092-4.447C53.952,13.88,44.878,7.591,34.618,7.592A26.7,26.7,0,0,0,26.29,8.955",
    transform: "translate(-9.428 -7.592)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_54362",
    "data-name": "Group 54362"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_54361",
    "data-name": "Group 54361",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86194",
    "data-name": "Path 86194",
    d: "M163.349,71.394v-.076a10.65,10.65,0,0,1,10.989-10.686,9.7,9.7,0,0,1,8.753,4.585L178.2,68.855a4.418,4.418,0,0,0-3.827-2.16c-2.312,0-4.017,2.046-4.017,4.547v.076c0,2.652,1.668,4.66,4.092,4.66a4.915,4.915,0,0,0,3.941-2.122l4.812,3.486a10.173,10.173,0,0,1-9.132,4.7,10.578,10.578,0,0,1-10.724-10.648",
    transform: "translate(-97.964 -36.362)",
    fill: "#65bcb0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86195",
    "data-name": "Path 86195",
    d: "M216.736,75.846V75.77c0-4.244,3.221-6.442,8.033-6.442a15.729,15.729,0,0,1,4.926.8v-.341c0-2.122-1.326-3.335-4.092-3.335a14.436,14.436,0,0,0-5.646,1.137l-1.477-5.077a20.581,20.581,0,0,1,8.3-1.592c3.676,0,6.177.872,7.806,2.5,1.554,1.516,2.2,3.638,2.2,6.517V81.719h-7.124V79.6a7.731,7.731,0,0,1-6.025,2.576c-3.9,0-6.9-2.236-6.9-6.328m13.035-1.554v-.947a7.537,7.537,0,0,0-2.8-.53c-2.084,0-3.3,1.023-3.3,2.538v.076a2.259,2.259,0,0,0,2.539,2.236,3.3,3.3,0,0,0,3.562-3.373",
    transform: "translate(-129.982 -36.533)",
    fill: "#65bcb0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86196",
    "data-name": "Path 86196",
    d: "M275.993,61.149h7.2v4.13c1.175-2.8,3.069-4.622,6.48-4.471v7.579h-.606c-3.752,0-5.874,2.16-5.874,6.9v6.366h-7.2Z",
    transform: "translate(-165.52 -36.463)",
    fill: "#65bcb0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86197",
    "data-name": "Path 86197",
    d: "M313.478,71.338v-.076c0-5.987,4.282-10.723,10.345-10.723,7.086,0,10.345,5.191,10.345,11.216,0,.455,0,.985-.038,1.478H320.412a4.231,4.231,0,0,0,4.433,3.372,6.186,6.186,0,0,0,4.547-2.084l3.979,3.3a10.737,10.737,0,0,1-8.9,4.168c-6.442,0-10.989-4.282-10.989-10.648m13.944-1.781c-.265-2.274-1.592-3.713-3.562-3.713-1.895,0-3.183,1.477-3.562,3.713Z",
    transform: "translate(-188 -36.307)",
    fill: "#65bcb0"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_54364",
    "data-name": "Group 54364",
    transform: "translate(3.774 3.039)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_54363",
    "data-name": "Group 54363",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8792",
    "data-name": "Rectangle 8792",
    width: 0.399,
    height: 52.918,
    transform: "translate(-0.245 -3.039)",
    fill: "#397fb7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8793",
    "data-name": "Rectangle 8793",
    width: 0.399,
    height: 52.918,
    transform: "translate(0.155 -3.039)",
    fill: "#397fb7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8794",
    "data-name": "Rectangle 8794",
    width: 0.399,
    height: 52.918,
    transform: "translate(0.554 -3.039)",
    fill: "#3a7fb7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8795",
    "data-name": "Rectangle 8795",
    width: 0.399,
    height: 52.918,
    transform: "translate(0.953 -3.039)",
    fill: "#3a80b7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8796",
    "data-name": "Rectangle 8796",
    width: 0.399,
    height: 52.918,
    transform: "translate(1.352 -3.039)",
    fill: "#3a80b7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8797",
    "data-name": "Rectangle 8797",
    width: 0.399,
    height: 52.918,
    transform: "translate(1.751 -3.039)",
    fill: "#3a81b7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8798",
    "data-name": "Rectangle 8798",
    width: 0.399,
    height: 52.918,
    transform: "translate(2.151 -3.039)",
    fill: "#3b81b7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8799",
    "data-name": "Rectangle 8799",
    width: 0.399,
    height: 52.918,
    transform: "translate(2.55 -3.039)",
    fill: "#3a82b7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8800",
    "data-name": "Rectangle 8800",
    width: 0.399,
    height: 52.918,
    transform: "translate(2.949 -3.039)",
    fill: "#3b82b6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8801",
    "data-name": "Rectangle 8801",
    width: 0.399,
    height: 52.918,
    transform: "translate(3.348 -3.039)",
    fill: "#3b82b7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8802",
    "data-name": "Rectangle 8802",
    width: 0.399,
    height: 52.918,
    transform: "translate(3.747 -3.039)",
    fill: "#3b83b6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8803",
    "data-name": "Rectangle 8803",
    width: 0.399,
    height: 52.918,
    transform: "translate(4.147 -3.039)",
    fill: "#3c83b6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8804",
    "data-name": "Rectangle 8804",
    width: 0.399,
    height: 52.918,
    transform: "translate(4.546 -3.039)",
    fill: "#3c83b6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8805",
    "data-name": "Rectangle 8805",
    width: 0.399,
    height: 52.918,
    transform: "translate(4.945 -3.039)",
    fill: "#3c84b6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8806",
    "data-name": "Rectangle 8806",
    width: 0.399,
    height: 52.918,
    transform: "translate(5.344 -3.039)",
    fill: "#3c84b6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8807",
    "data-name": "Rectangle 8807",
    width: 0.399,
    height: 52.918,
    transform: "translate(5.743 -3.039)",
    fill: "#3c85b6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8808",
    "data-name": "Rectangle 8808",
    width: 0.399,
    height: 52.918,
    transform: "translate(6.142 -3.039)",
    fill: "#3d85b6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8809",
    "data-name": "Rectangle 8809",
    width: 0.399,
    height: 52.918,
    transform: "translate(6.541 -3.039)",
    fill: "#3d86b6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8810",
    "data-name": "Rectangle 8810",
    width: 0.399,
    height: 52.918,
    transform: "translate(6.94 -3.039)",
    fill: "#3d86b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8811",
    "data-name": "Rectangle 8811",
    width: 0.399,
    height: 52.918,
    transform: "translate(7.34 -3.039)",
    fill: "#3d86b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8812",
    "data-name": "Rectangle 8812",
    width: 0.399,
    height: 52.918,
    transform: "translate(7.739 -3.039)",
    fill: "#3d87b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8813",
    "data-name": "Rectangle 8813",
    width: 0.399,
    height: 52.918,
    transform: "translate(8.138 -3.039)",
    fill: "#3e87b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8814",
    "data-name": "Rectangle 8814",
    width: 0.399,
    height: 52.918,
    transform: "translate(8.537 -3.039)",
    fill: "#3e88b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8815",
    "data-name": "Rectangle 8815",
    width: 0.399,
    height: 52.918,
    transform: "translate(8.936 -3.039)",
    fill: "#3e88b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8816",
    "data-name": "Rectangle 8816",
    width: 0.399,
    height: 52.918,
    transform: "translate(9.335 -3.039)",
    fill: "#3e88b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8817",
    "data-name": "Rectangle 8817",
    width: 0.399,
    height: 52.918,
    transform: "translate(9.735 -3.039)",
    fill: "#3f89b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8818",
    "data-name": "Rectangle 8818",
    width: 0.399,
    height: 52.918,
    transform: "translate(10.134 -3.039)",
    fill: "#3f89b4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8819",
    "data-name": "Rectangle 8819",
    width: 0.399,
    height: 52.918,
    transform: "translate(10.533 -3.039)",
    fill: "#3f8ab4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8820",
    "data-name": "Rectangle 8820",
    width: 0.399,
    height: 52.918,
    transform: "translate(10.932 -3.039)",
    fill: "#3f8ab4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8821",
    "data-name": "Rectangle 8821",
    width: 0.399,
    height: 52.918,
    transform: "translate(11.331 -3.039)",
    fill: "#3f8ab4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8822",
    "data-name": "Rectangle 8822",
    width: 0.399,
    height: 52.918,
    transform: "translate(11.731 -3.039)",
    fill: "#408bb4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8823",
    "data-name": "Rectangle 8823",
    width: 0.399,
    height: 52.918,
    transform: "translate(12.13 -3.039)",
    fill: "#408bb4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8824",
    "data-name": "Rectangle 8824",
    width: 0.399,
    height: 52.918,
    transform: "translate(12.529 -3.039)",
    fill: "#408cb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8825",
    "data-name": "Rectangle 8825",
    width: 0.399,
    height: 52.918,
    transform: "translate(12.928 -3.039)",
    fill: "#408cb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8826",
    "data-name": "Rectangle 8826",
    width: 0.399,
    height: 52.918,
    transform: "translate(13.327 -3.039)",
    fill: "#408cb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8827",
    "data-name": "Rectangle 8827",
    width: 0.399,
    height: 52.918,
    transform: "translate(13.726 -3.039)",
    fill: "#418db3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8828",
    "data-name": "Rectangle 8828",
    width: 0.399,
    height: 52.918,
    transform: "translate(14.125 -3.039)",
    fill: "#418db3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8829",
    "data-name": "Rectangle 8829",
    width: 0.399,
    height: 52.918,
    transform: "translate(14.524 -3.039)",
    fill: "#418eb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8830",
    "data-name": "Rectangle 8830",
    width: 0.399,
    height: 52.918,
    transform: "translate(14.924 -3.039)",
    fill: "#418eb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8831",
    "data-name": "Rectangle 8831",
    width: 0.399,
    height: 52.918,
    transform: "translate(15.323 -3.039)",
    fill: "#418fb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8832",
    "data-name": "Rectangle 8832",
    width: 0.399,
    height: 52.918,
    transform: "translate(15.722 -3.039)",
    fill: "#428fb2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8833",
    "data-name": "Rectangle 8833",
    width: 0.399,
    height: 52.918,
    transform: "translate(16.121 -3.039)",
    fill: "#428fb2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8834",
    "data-name": "Rectangle 8834",
    width: 0.399,
    height: 52.918,
    transform: "translate(16.52 -3.039)",
    fill: "#4290b2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8835",
    "data-name": "Rectangle 8835",
    width: 0.399,
    height: 52.918,
    transform: "translate(16.92 -3.039)",
    fill: "#4290b2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8836",
    "data-name": "Rectangle 8836",
    width: 0.399,
    height: 52.918,
    transform: "translate(17.319 -3.039)",
    fill: "#4391b2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8837",
    "data-name": "Rectangle 8837",
    width: 0.399,
    height: 52.918,
    transform: "translate(17.718 -3.039)",
    fill: "#4391b2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8838",
    "data-name": "Rectangle 8838",
    width: 0.399,
    height: 52.918,
    transform: "translate(18.117 -3.039)",
    fill: "#4391b2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8839",
    "data-name": "Rectangle 8839",
    width: 0.399,
    height: 52.918,
    transform: "translate(18.516 -3.039)",
    fill: "#4392b1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8840",
    "data-name": "Rectangle 8840",
    width: 0.399,
    height: 52.918,
    transform: "translate(18.915 -3.039)",
    fill: "#4492b1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8841",
    "data-name": "Rectangle 8841",
    width: 0.399,
    height: 52.918,
    transform: "translate(19.315 -3.039)",
    fill: "#4493b1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8842",
    "data-name": "Rectangle 8842",
    width: 0.399,
    height: 52.918,
    transform: "translate(19.714 -3.039)",
    fill: "#4493b1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8843",
    "data-name": "Rectangle 8843",
    width: 0.399,
    height: 52.918,
    transform: "translate(20.113 -3.039)",
    fill: "#4493b1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8844",
    "data-name": "Rectangle 8844",
    width: 0.399,
    height: 52.918,
    transform: "translate(20.512 -3.039)",
    fill: "#4494b1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8845",
    "data-name": "Rectangle 8845",
    width: 0.399,
    height: 52.918,
    transform: "translate(20.911 -3.039)",
    fill: "#4594b0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8846",
    "data-name": "Rectangle 8846",
    width: 0.399,
    height: 52.918,
    transform: "translate(21.31 -3.039)",
    fill: "#4595b0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8847",
    "data-name": "Rectangle 8847",
    width: 0.399,
    height: 52.918,
    transform: "translate(21.709 -3.039)",
    fill: "#4595b0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8848",
    "data-name": "Rectangle 8848",
    width: 0.399,
    height: 52.918,
    transform: "translate(22.109 -3.039)",
    fill: "#4695b0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8849",
    "data-name": "Rectangle 8849",
    width: 0.399,
    height: 52.918,
    transform: "translate(22.508 -3.039)",
    fill: "#4696b0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8850",
    "data-name": "Rectangle 8850",
    width: 0.399,
    height: 52.918,
    transform: "translate(22.907 -3.039)",
    fill: "#4696b0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8851",
    "data-name": "Rectangle 8851",
    width: 0.399,
    height: 52.918,
    transform: "translate(23.306 -3.039)",
    fill: "#4697af"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8852",
    "data-name": "Rectangle 8852",
    width: 0.399,
    height: 52.918,
    transform: "translate(23.705 -3.039)",
    fill: "#4697af"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8853",
    "data-name": "Rectangle 8853",
    width: 0.399,
    height: 52.918,
    transform: "translate(24.105 -3.039)",
    fill: "#4797af"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8854",
    "data-name": "Rectangle 8854",
    width: 0.399,
    height: 52.918,
    transform: "translate(24.504 -3.039)",
    fill: "#4798af"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8855",
    "data-name": "Rectangle 8855",
    width: 0.399,
    height: 52.918,
    transform: "translate(24.903 -3.039)",
    fill: "#4798af"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8856",
    "data-name": "Rectangle 8856",
    width: 0.399,
    height: 52.918,
    transform: "translate(25.302 -3.039)",
    fill: "#4799ae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8857",
    "data-name": "Rectangle 8857",
    width: 0.399,
    height: 52.918,
    transform: "translate(25.701 -3.039)",
    fill: "#4899ae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8858",
    "data-name": "Rectangle 8858",
    width: 0.399,
    height: 52.918,
    transform: "translate(26.1 -3.039)",
    fill: "#489aae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8859",
    "data-name": "Rectangle 8859",
    width: 0.399,
    height: 52.918,
    transform: "translate(26.5 -3.039)",
    fill: "#489aae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8860",
    "data-name": "Rectangle 8860",
    width: 0.399,
    height: 52.918,
    transform: "translate(26.899 -3.039)",
    fill: "#489aae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8861",
    "data-name": "Rectangle 8861",
    width: 0.399,
    height: 52.918,
    transform: "translate(27.298 -3.039)",
    fill: "#499bae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8862",
    "data-name": "Rectangle 8862",
    width: 0.399,
    height: 52.918,
    transform: "translate(27.697 -3.039)",
    fill: "#499bad"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8863",
    "data-name": "Rectangle 8863",
    width: 0.399,
    height: 52.918,
    transform: "translate(28.096 -3.039)",
    fill: "#499bad"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8864",
    "data-name": "Rectangle 8864",
    width: 0.399,
    height: 52.918,
    transform: "translate(28.495 -3.039)",
    fill: "#499cad"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8865",
    "data-name": "Rectangle 8865",
    width: 0.399,
    height: 52.918,
    transform: "translate(28.894 -3.039)",
    fill: "#499cad"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8866",
    "data-name": "Rectangle 8866",
    width: 0.399,
    height: 52.918,
    transform: "translate(29.293 -3.039)",
    fill: "#4a9dad"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8867",
    "data-name": "Rectangle 8867",
    width: 0.399,
    height: 52.918,
    transform: "translate(29.693 -3.039)",
    fill: "#4a9dac"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8868",
    "data-name": "Rectangle 8868",
    width: 0.399,
    height: 52.918,
    transform: "translate(30.092 -3.039)",
    fill: "#4a9eac"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8869",
    "data-name": "Rectangle 8869",
    width: 0.399,
    height: 52.918,
    transform: "translate(30.491 -3.039)",
    fill: "#4a9eac"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8870",
    "data-name": "Rectangle 8870",
    width: 0.399,
    height: 52.918,
    transform: "translate(30.89 -3.039)",
    fill: "#4b9eac"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8871",
    "data-name": "Rectangle 8871",
    width: 0.399,
    height: 52.918,
    transform: "translate(31.29 -3.039)",
    fill: "#4b9fac"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8872",
    "data-name": "Rectangle 8872",
    width: 0.399,
    height: 52.918,
    transform: "translate(31.689 -3.039)",
    fill: "#4b9fab"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8873",
    "data-name": "Rectangle 8873",
    width: 0.399,
    height: 52.918,
    transform: "translate(32.088 -3.039)",
    fill: "#4ba0ab"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8874",
    "data-name": "Rectangle 8874",
    width: 0.399,
    height: 52.918,
    transform: "translate(32.487 -3.039)",
    fill: "#4ca0ab"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8875",
    "data-name": "Rectangle 8875",
    width: 0.399,
    height: 52.918,
    transform: "translate(32.886 -3.039)",
    fill: "#4ca0ab"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8876",
    "data-name": "Rectangle 8876",
    width: 0.399,
    height: 52.918,
    transform: "translate(33.285 -3.039)",
    fill: "#4ca1aa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8877",
    "data-name": "Rectangle 8877",
    width: 0.399,
    height: 52.918,
    transform: "translate(33.684 -3.039)",
    fill: "#4ca1aa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8878",
    "data-name": "Rectangle 8878",
    width: 0.399,
    height: 52.918,
    transform: "translate(34.084 -3.039)",
    fill: "#4ca2aa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8879",
    "data-name": "Rectangle 8879",
    width: 0.399,
    height: 52.918,
    transform: "translate(34.483 -3.039)",
    fill: "#4da2aa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8880",
    "data-name": "Rectangle 8880",
    width: 0.399,
    height: 52.918,
    transform: "translate(34.882 -3.039)",
    fill: "#4da2aa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8881",
    "data-name": "Rectangle 8881",
    width: 0.399,
    height: 52.918,
    transform: "translate(35.281 -3.039)",
    fill: "#4da3a9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8882",
    "data-name": "Rectangle 8882",
    width: 0.399,
    height: 52.918,
    transform: "translate(35.68 -3.039)",
    fill: "#4da3a9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8883",
    "data-name": "Rectangle 8883",
    width: 0.399,
    height: 52.918,
    transform: "translate(36.079 -3.039)",
    fill: "#4ea4a9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8884",
    "data-name": "Rectangle 8884",
    width: 0.399,
    height: 52.918,
    transform: "translate(36.478 -3.039)",
    fill: "#4ea4a9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8885",
    "data-name": "Rectangle 8885",
    width: 0.399,
    height: 52.918,
    transform: "translate(36.878 -3.039)",
    fill: "#4ea4a8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8886",
    "data-name": "Rectangle 8886",
    width: 0.399,
    height: 52.918,
    transform: "translate(37.277 -3.039)",
    fill: "#4ea5a8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8887",
    "data-name": "Rectangle 8887",
    width: 0.399,
    height: 52.918,
    transform: "translate(37.676 -3.039)",
    fill: "#4fa5a8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8888",
    "data-name": "Rectangle 8888",
    width: 0.399,
    height: 52.918,
    transform: "translate(38.075 -3.039)",
    fill: "#4fa6a8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8889",
    "data-name": "Rectangle 8889",
    width: 0.399,
    height: 52.918,
    transform: "translate(38.474 -3.039)",
    fill: "#4fa6a8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8890",
    "data-name": "Rectangle 8890",
    width: 0.399,
    height: 52.918,
    transform: "translate(38.874 -3.039)",
    fill: "#4fa6a7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8891",
    "data-name": "Rectangle 8891",
    width: 0.399,
    height: 52.918,
    transform: "translate(39.273 -3.039)",
    fill: "#50a7a7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8892",
    "data-name": "Rectangle 8892",
    width: 0.399,
    height: 52.918,
    transform: "translate(39.672 -3.039)",
    fill: "#50a7a7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8893",
    "data-name": "Rectangle 8893",
    width: 0.399,
    height: 52.918,
    transform: "translate(40.071 -3.039)",
    fill: "#50a8a7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8894",
    "data-name": "Rectangle 8894",
    width: 0.399,
    height: 52.918,
    transform: "translate(40.47 -3.039)",
    fill: "#50a8a6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8895",
    "data-name": "Rectangle 8895",
    width: 0.399,
    height: 52.918,
    transform: "translate(40.869 -3.039)",
    fill: "#50a9a6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8896",
    "data-name": "Rectangle 8896",
    width: 0.399,
    height: 52.918,
    transform: "translate(41.269 -3.039)",
    fill: "#51a9a6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8897",
    "data-name": "Rectangle 8897",
    width: 0.399,
    height: 52.918,
    transform: "translate(41.668 -3.039)",
    fill: "#51a9a6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8898",
    "data-name": "Rectangle 8898",
    width: 0.399,
    height: 52.918,
    transform: "translate(42.067 -3.039)",
    fill: "#51aaa5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8899",
    "data-name": "Rectangle 8899",
    width: 0.399,
    height: 52.918,
    transform: "translate(42.466 -3.039)",
    fill: "#52aaa5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8900",
    "data-name": "Rectangle 8900",
    width: 0.399,
    height: 52.918,
    transform: "translate(42.865 -3.039)",
    fill: "#52aba5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8901",
    "data-name": "Rectangle 8901",
    width: 0.399,
    height: 52.918,
    transform: "translate(43.264 -3.039)",
    fill: "#52aba5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8902",
    "data-name": "Rectangle 8902",
    width: 0.399,
    height: 52.918,
    transform: "translate(43.663 -3.039)",
    fill: "#52aba4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8903",
    "data-name": "Rectangle 8903",
    width: 0.399,
    height: 52.918,
    transform: "translate(44.063 -3.039)",
    fill: "#53aca4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8904",
    "data-name": "Rectangle 8904",
    width: 0.399,
    height: 52.918,
    transform: "translate(44.462 -3.039)",
    fill: "#53aca4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8905",
    "data-name": "Rectangle 8905",
    width: 0.399,
    height: 52.918,
    transform: "translate(44.861 -3.039)",
    fill: "#53ada3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8906",
    "data-name": "Rectangle 8906",
    width: 0.399,
    height: 52.918,
    transform: "translate(45.26 -3.039)",
    fill: "#53ada3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8907",
    "data-name": "Rectangle 8907",
    width: 0.399,
    height: 52.918,
    transform: "translate(45.659 -3.039)",
    fill: "#54ada3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8908",
    "data-name": "Rectangle 8908",
    width: 0.399,
    height: 52.918,
    transform: "translate(46.059 -3.039)",
    fill: "#54aea3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8909",
    "data-name": "Rectangle 8909",
    width: 0.399,
    height: 52.918,
    transform: "translate(46.458 -3.039)",
    fill: "#54aea2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8910",
    "data-name": "Rectangle 8910",
    width: 0.399,
    height: 52.918,
    transform: "translate(46.857 -3.039)",
    fill: "#54afa2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8911",
    "data-name": "Rectangle 8911",
    width: 0.399,
    height: 52.918,
    transform: "translate(47.256 -3.039)",
    fill: "#55afa2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8912",
    "data-name": "Rectangle 8912",
    width: 0.399,
    height: 52.918,
    transform: "translate(47.655 -3.039)",
    fill: "#55afa2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8913",
    "data-name": "Rectangle 8913",
    width: 0.399,
    height: 52.918,
    transform: "translate(48.054 -3.039)",
    fill: "#55b0a1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8914",
    "data-name": "Rectangle 8914",
    width: 0.399,
    height: 52.918,
    transform: "translate(48.453 -3.039)",
    fill: "#55b0a1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8915",
    "data-name": "Rectangle 8915",
    width: 0.399,
    height: 52.918,
    transform: "translate(48.853 -3.039)",
    fill: "#56b1a1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8916",
    "data-name": "Rectangle 8916",
    width: 0.399,
    height: 52.918,
    transform: "translate(49.252 -3.039)",
    fill: "#56b1a1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8917",
    "data-name": "Rectangle 8917",
    width: 9.634,
    height: 52.918,
    transform: "translate(49.651 -3.039)",
    fill: "#56b1a1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLogo);
export default __webpack_public_path__ + "static/media/newLogo.b523a052a6803a962e09abd876cd00df.svg";
export { ForwardRef as ReactComponent };